module.exports = __webpack_public_path__ + "img/close.8e411962.svg";